import { lookupWordByUid } from '../index';

export default (subjects, state) => {
  let invertedA = false;
  let invertedB = false;

  if (subjects[0].type === 'external') {
    invertedA = lookupWordByUid(state, 'exi' + subjects[0].id) === '1';
  }
  if (subjects[1].type === 'external') {
    invertedB = lookupWordByUid(state, 'exi' + subjects[1].id) === '1';
  }

  return (invertedA && !invertedB) || (!invertedA && invertedB);
};
